module.exports = __webpack_public_path__ + "img/cplusImage.83611c33.png";